import { all, call, fork, put, takeLatest, select } from 'redux-saga/effects';
import { FETCH_RESPONSES, FETCH_RESPONSES_IF_NEEDED, UPDATE_NOTEWORTHY_RESPONSES } from '../actions/actionTypes';
import {
  fetchNoteworthyError,
  fetchNoteworthySuccess,
  fetchResponsesDone,
  fetchResponsesError,
  fetchResponsesLoading,
  fetchResponsesSuccess,
  fetchResponses,
  applyCachedResponses,
  storeResponsesCache,
  updateNoteworthyResponsesDone,
  updateNoteworthyResponsesError,
  updateNoteworthyResponsesLoading,
  updateNoteworthyResponsesSuccess
} from '../actions/responses';
import { eventApi } from '../api/EventApi';

// Create your Saga here...

export function* watchFetchResponsesIfNeededSaga () {
  yield takeLatest(FETCH_RESPONSES_IF_NEEDED, fetchResponsesIfNeededSaga);
}

export function* watchFetchResponsesSaga () {
  yield takeLatest(FETCH_RESPONSES, fetchResponsesSaga);
}

export function* fetchResponsesIfNeededSaga ({ eventId }) {
  const state = yield select();
  const cacheEntry = state.responses?.cache?.[eventId];
  const TTL_MS = 10 * 60 * 1000; // 10 minutes
  // console.log('fetchResponsesIfNeededSaga: eventId', eventId, 'cacheEntry', cacheEntry);
  const isFresh = cacheEntry && (Date.now() - cacheEntry.fetchedAt) < TTL_MS;
  // console.log('Is cache fresh?', isFresh, 'TTL_MS', TTL_MS);
  if (isFresh) {
    // console.log('Cache hit – using cached responses for event', eventId);
    yield put(applyCachedResponses(eventId, cacheEntry.data));
  } else {
    // Delegate to normal fetch flow
    // console.log('Cache miss or stale – dispatching FETCH_RESPONSES for', eventId);
    yield put(fetchResponses(eventId));
  }
}

export function* fetchResponsesSaga ({ eventId }) {
  // console.log('========== RESULTS TAB: FETCHING DATA ==========');
  // console.log('Fetching responses for event ID:', eventId);
  
  yield put(fetchResponsesLoading());
  
  try {
    // console.log('Making API calls to fetch posts and noteworthy posts');
    const results = yield all([
      call(eventApi.fetchAllPosts, eventId),
      call(eventApi.fetchNoteworthy, eventId)
    ]);
    
    // console.log('API calls completed, processing results');
    
    const { postsError, ...posts } = results[0];
    const { noteworthyError, ...noteworthy } = results[1];
    
    //console.log('Posts response:', JSON.stringify(posts, null, 2));
    //console.log('Noteworthy response:', JSON.stringify(noteworthy, null, 2));
    
    if (postsError) {
      console.error('Error fetching posts:', postsError);
      yield put(fetchResponsesError(postsError));
    } else {
      // console.log('Successfully fetched posts. Total count:', posts.posts?.length || 0);
      yield put(fetchResponsesSuccess(posts));
      // Store combined data in cache
      const combinedData = { posts, noteworthy_posts: noteworthy.posts };
      const nowTs = Date.now();
      // console.log('Storing responses in cache at', nowTs, 'for event', eventId);
      yield put(storeResponsesCache(eventId, combinedData, nowTs));
    }

    if (noteworthyError) {
      console.error('Error fetching noteworthy posts:', noteworthyError);
      yield put(fetchNoteworthyError(noteworthyError));
    } else {
      // console.log('Successfully fetched noteworthy posts. Total count:', noteworthy.posts?.length || 0);
      yield put(fetchNoteworthySuccess(noteworthy));
    }
    
    // console.log('========== RESULTS TAB: DATA FETCH COMPLETE ==========');
  } catch (error) {
    console.error('Unexpected error in fetchResponsesSaga:', error);
    yield put(fetchResponsesError(error));
  } finally {
    yield put(fetchResponsesDone());
  }
}

export function* watchUpdateNoteworthyResponsesSaga () {
  yield takeLatest(UPDATE_NOTEWORTHY_RESPONSES, updateNoteworthyResponsesSaga);
}

export function* updateNoteworthyResponsesSaga ({ eventId, postIds }) {
  try {
    yield put(updateNoteworthyResponsesLoading());
    const result = yield call(eventApi.markNoteworthy, eventId, postIds);
    yield put(updateNoteworthyResponsesSuccess(result));
  } catch (error) {
    yield put(updateNoteworthyResponsesError(error));
  } finally {
    yield put(updateNoteworthyResponsesDone());
  }
}

export default [
  fork(watchFetchResponsesIfNeededSaga),
  fork(watchFetchResponsesSaga),
  fork(watchUpdateNoteworthyResponsesSaga)
];
